import React from 'react'
import { useStore } from 'stook'

export default function useOrderType() {
  const [orderType, setOrderType] = useStore('OrderTypeDefault', {
    default: localStorage.getItem('__ss_ms_order_type_default') || '',
  })

  const updateOrderType = (type: string) => {
    setOrderType((state) => {
      state.default = type
      localStorage.setItem('__ss_ms_order_type_default', type)
    })
  }

  return {
    orderType,
    updateOrderType,
  }
}
